export const STORAGE_KEYS = {
  // Legacy value name — kept for continuity with older browser sessions that
  // authenticated pre-OTP-rewrite under this key. The name will be renamed
  // to "VENDOR_TASKER_TOKEN" in a future cleanup once vendor sessions have
  // rotated (post OTP-flow rollout).
  VENDOR_TOKEN: "GVM_VENDOR_SESSION",
  VENDOR_MOBILE: "VENDOR_MOBILE",
  VENDOR_MOBILE_COUNTRY_CODE: "VENDOR_MOBILE_COUNTRY_CODE",
  REVIEWER_TOKEN: "REVIEWER_TASKER_TOKEN",
  REVIEWER_TOKEN_EXPIRES: "REVIEWER_TASKER_TOKEN_EXPIRES_AT",
} as const;

export function submissionMarkerKey(taskId: string): string {
  return `vo:submitted:${taskId}`;
}
